import { EEventStatus, EEventType } from 'enums/lei/leiDetailDataEnums';
import { EJinyTyp } from 'enums/lei/leiJinyTypEnums';
import { ELeiStavZadosti } from 'enums/lei/leiStavZadosti';
import { EMaterskaSpol } from 'enums/lei/materskaSpol';
import { ETypAdresy } from 'enums/lei/typAdresy';
import { ETypNazvu } from 'enums/lei/typNazvu';

import {
    EKonsolidace,
    EPeriodType,
    ESubCategoryLei,
    ETypDatMatky,
    ETypMatky,
    ETypZadostiLei
} from '../enums/lei/leiDataEnums';

export interface ILeiSubory {
    orignazev: string;
    tempnazev: string;
}

export interface IZalozeniLeiInput {
    jurisdikce?: string;
    registrationauthorityid?: string;
    otherregistrationauthorityid?: string;
    registrationauthorityentityid?: string;
    legalname?: string;
    typzadosti?: ETypZadostiLei;
}

export interface ICheckOsobaOR {
    ic: string;
    jmeno: string;
    prijmeni: string;
}

export interface ILeiCheckResp {
    stav: 'EXISTUJE' | 'NEEXISTUJE' | 'DUPLICITA';
    varsym?: string;
    lei: string;
    ic: string;
    spolecnost: string;
    stavlei: string;
    stat: string;
    lou: string;
    adresa: string;
    mesto: string;
    psc: string;
    region: string;
    kategorie: string;
}

export interface ILeiRejstrikInput {
    ic: string;
    stat: string;
    lang: string;
    regauthor: string;
}

export interface ILeiRejstrikResp {
    jurisdikce: string;
    region: string;
    registrationauthorityid: string;
    otherregistrationauthorityid: string;
    entitylegalformcode: string;
    entitycreationdate: string;
    legalname: string;
    adresy: {
        typadresy?: ETypAdresy;
        firstaddressline?: string;
        city?: string;
        postalcode?: string;
        country?: string;
        region?: string;
        lang?: string;
    }[];
    entitycheck?: string;
}

export interface ILeiDirHashInput {
    lei: string;
    ic: string;
    varsym: string;
    stat: string;
}

export interface ILeiDirListItem {
    oid: number;
    nazev: string;
    typ: string;
    oblast: string;
    url: string;
    velikost: string;
    vlozeno: string;
}

export interface ILeiDirResp {
    legalentityidentifier: string;
    businessregistryidentifier: string;
    registeredname: string;
    registeredaddress1: string;
    registeredcity: string;
    registeredpostalcode: string;
    registeredcountrycode: string;
    token: string;
    list: ILeiDirListItem[];
}

export interface ILeiContact {
    id?: number;
    contactname?: string;
    contactsurname?: string;
    contactemail?: string;
    contactemail2?: string;
    fakturacniemail?: string;
    contactphone?: string;
    contactjob?: string;
    typosoby?: string;
    madic?: boolean;
    dic?: string;
    soubory?: ILeiSubory[];
    omezenaplatnost?: boolean;
    platnost?: string;
    lang?: string; // toto tu je preco?
}

export interface ILeiAdresy {
    typadresy: ETypAdresy | string;
    firstaddressline?: string;
    additionaladdressline?: string;
    city?: string;
    postalcode?: string;
    country?: string;
    region?: string;
    lang?: string;
}
export interface ILeiMatka {
    selfmanaged?: boolean;
    typmatky?: ETypMatky | string;
    stav?: EMaterskaSpol;
    duvod?: string;
    exceptionreference?: string;
    matkaslei?: string;
    matkabezlei?: {
        jurisdikce?: string;
        registrationauthorityid?: string;
        otherregistrationauthorityid?: string;
        registrationauthorityentityid?: string;
        shodnaadresa?: boolean;
        adresy?: ILeiAdresy[];
        entitycheck?: string; // toto co?
    };
    informacekmatce?: {
        datumodkdyplatnost?: string;
        konsolidace?: EKonsolidace | string;
        podilspolecnosti?: number;
        soubory?: ILeiSubory[];
        validationdocuments?: ETypDatMatky | string;
        validationreference?: string;
        relationshipperiod?: {
            startdate?: string;
            enddate?: string;
            periodtype?: EPeriodType | string;
        }[];
    };
}

export interface ILeiOtherEntityNames {
    otherentityname?: string;
    entitynametype?: string;
    lang?: string;
}

export interface ILeiDataSpolecnost {
    legalentityidentifier?: string; // pouzite len pri uprave lei
    shodnaadresa?: boolean;
    registrationauthorityid?: string;
    jurisdikce?: string;
    otherregistrationauthorityid?: string;
    registrationauthorityentityid?: string;
    legalname?: string;
    transliteratedotherentitynames?: string;
    transliteratedentitynametype?: ETypNazvu | string;
    otherentitynames?: ILeiOtherEntityNames[];
    otherentitynametype?: ETypNazvu | string;
    entitylegalformcode?: string;
    otherlegalform?: string;
    // entitystatus?: string;
    entitycreationddate?: string;
    nextrenewaldate?: string;
    registrationstatus?: string;
    dic?: string;
    entitycheck?: string;
    jinazmena?: string;
    adresy?: ILeiAdresy[];
}

export interface ILeiData {
    typzadosti?: ETypZadostiLei;
    subcategory?: ESubCategoryLei;
    osoba?: ILeiContact;
    spolecnost?: ILeiDataSpolecnost;
    language?: string;
    entitycheck?: string;
    matky?: ILeiMatka[];
    platba?: ELeiPlatba;
    url?: string;
    soubor?: {
        orignazev: string;
        tempnazev: string;
    };
}

export interface ILeiDetailEvent {
    eventstatus?: EEventStatus;
    idzadosti?: string | number;
    ostatnievent?: EJinyTyp;
    datumzmeny?: string;
    datumprogres?: string;
    datumcompleted?: string;
    eventtype?: EEventType;
    validationdocuments?: ETypDatMatky | string;
    soubory?: ILeiSubory[];
    hlasenyzmeny?: {
        spolecnost: ILeiDataSpolecnost;
        jurisdikce: string;
        successorentitylei?: string;
        successorentityname?: string;
        popis?: string;
    };
}

export enum EStavLeiPlatba {
    PREVOD = 'PREVOD',
    ZAPLACENO = 'ZAPLACENO',
    VYRIZENO = 'VYRIZENO',
    VRACENO = 'VRACENO',
    ZRUSENO = 'ZRUSENO',
    ZAPLATIT = 'ZAPLATIT',
    CEKANAVYR = 'CEKANAVYR'
}
export enum EStavLeiPlatby {
    PLZRUS = 'PLZRUS', // zrušená platba
    PLODLO = 'PLODLO', // odložená platba
    PLZAPL = 'PLZAPL', // zaplaceno
    CEKA = 'CEKA', // čeká na odpověď
    ZPRAC = 'ZPRAC', // výsledek odpovědi je zpracovaný
    VYPR = 'VYPR' // vypršela platnost žádosti
}

export interface ELeiPlatba {
    mena?: string;
    castka?: number;
    typplatby?: 'KARTOU' | 'PREVODEM';
    idplatby?: string;
    stavplatby?: EStavLeiPlatby;
    token?: string;
}

export interface ILeiDetailData {
    fakturace?: {
        nazev: string;
        datum: string;
    }[];
    stav?: ELeiStavZadosti;
    events?: ILeiDetailEvent[];
    platbaspe?: string;
    platbavar?: string;
    paymentduedate?: string;
    typzadosti?: ETypZadostiLei;
    subcategory?: ESubCategoryLei;
    osoba?: ILeiContact;
    spolecnost?: ILeiDataSpolecnost;
    language?: string;
    matky?: ILeiMatka[];
    entitycheck?: string;
    stavleiplatba?: EStavLeiPlatba;
    platba?: ELeiPlatba;
    url?: string;
    lastupdate?: string;
}

export interface ILeiPrevod {
    platbavar?: string;
    platbaspe?: string;
    id?: number;
    stav?: ELeiStavZadosti;
    typzadosti?: ETypZadostiLei;
    subcategory?: ESubCategoryLei;
    osoba?: ILeiContact;
    spolecnost?: ILeiDataSpolecnost;
    entitycheck?: string;
    language?: string;
    matky?: ILeiMatka[];
    platba?: ELeiPlatba;
    events?: ILeiDetailEvent[];
    soubory?: ILeiSubory[];
}
